export const theme = {
  colors: {
    brand: "#007AC9",
    brandDarker: "#0068ab",
    tweakedBrand: "#0074bf",
    tweakedBrandDarker30: "#005186",
    stop: "#004B7B",
    background: {
      grey: "#F2F5F7",
      hoverGrey: "#D9D9D9",
      hslBlue: "#BFDEF1",
      hslCityBikeYellow: "#FFF3BF",
      hslCommuterTrainPurple: "#E2D1E5",
      hslFerry10: "#EFF8FD",
      hslFerryBlue: "#BFEDF8",
      hslGreen: "#D8EFC7",
      hslGreen10: "#F3F9EF",
      hslMetroOrange: "#FFD8C5",
      hslPink: "#FBE4F3",
      hslPink10: "#FCF7FA",
      hslSpeedTramTurquoise: "#BFECE9",
      hslTramGreen: "#BFE5D7",
      hslWarningSurface: "#FFF8E8",
      hslButtonSelected: "#003456",
    },
    border: {
      hslBlue: "#B1D6EE",
      hslCityBikeYellow: "#FFE880",
      hslCommuterTrainPurple: "#C5A3CC",
      hslFerry10: "#DFF1FB",
      hslFerryBlue: "#80DCF1",
      hslGreen: "#B1DF8E",
      hslGreen10: "#E7F3DE",
      hslMetroOrange: "#FFB18C",
      hslPink: "#F7C9E6",
      hslPink10: "#F9EFF5",
      hslSpeedTramTurquoise: "#80D9D4",
      hslTramGreen: "#80CBAF",
      weak: "#DDDDDD",
    },
    hslDark80: "#333333",
    grey: "#888888",
    lightGrey: "#CCCCCC",
    lighterGrey: "#FBFCFD",
    darkGrey: "#666666",
    hslLightGreen: "#64BE1E",
    hslDarkGreen: "#3B7F00",
    hslTramGreen: "#00985F",
    hslTramDarkGreen: "#008151",
    hslSpeedTramTurquoise: "#007D78",
    hslFerryBlue: "#007A97",
    hslMetroOrange: "#CA4000",
    hslTrunkLineOrange: "#CA4000",
    hslTrainPurple: "#8C4799",
    hslRed: "#DC0451",
    hslNeutralBlue: "#E5F2FA",
    cityBicycleYellow: "#FCBC19",
    hslWarningYellow: "#FED100",
    hslWarningRed: "#CA4000",
    hslHighlightYellowDark: "#C89515",
    hslHighlightYellowLight: "#FFD771",
    hslLightPurple: "#DDC8E0",
    hslOrange: "#FFA87E",
    routes: {
      bus: "#0074BF",
      ferry: "#333333",
      metro: "#FF6319",
      train: "#8C4799",
      tram: "#00985F",
    },
    stops: {
      bus: "#004B7B",
      ferry: "#333333",
      metro: "#BF4A13",
      train: "#924C9F",
      tram: "#336D00",
    },
    stopStrokes: { tram: "#00613D", speedTram: "#005E5A" },
    selectedMapItem: "#DC0451",
    accentSecondary: "#C53291",
  },
};
